import { Link as MaterialLink, LinkProps } from '@mui/material';
import React from 'react';

/**
 * The Link
 *
 * @version [AIV]{version}[/AIV]
 * @author [SFP](https://gitlab.sfp.berlin/products/sparkasse.de/portals)
 * @see [https://styleguide.sparkasse.de/document/69#/cms-komponenten/external-link]
 * @see [https://styleguide.sparkasse.de/document/69#/cms-komponenten/thematischer-link]
 * @see [https://styleguide.sparkasse.de/document/69#/cms-komponenten/action-link]
 * @see [https://styleguide.sparkasse.de/document/69#/cms-komponenten/internal-link]
 */
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, color = 'text.link', ...props }, ref) => {
    return (
      <MaterialLink color={color} {...props} ref={ref}>
        {children}
      </MaterialLink>
    );
  }
);

Link.displayName = 'ref(Link)';
